import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const TasApplicationSchema = withDefaults({
  type: 'tas-application',
  objectExtensions: ['tas-application'],
  traits: ['commentable'],
  fields: [
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'fields',
    },
    {
      kind: 'attribute',
      name: 'customFields',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'paymentStateLog',
    },
    {
      kind: 'attribute',
      name: 'approvedTotalLog',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'attribute',
      name: 'coursesApproval',
    },
    {
      kind: 'attribute',
      name: 'evidenceApproval',
    },
    {
      kind: 'attribute',
      name: 'migrationApplicationId',
    },
    {
      kind: 'attribute',
      name: 'isTrial',
    },
    {
      kind: 'attribute',
      name: 'paymentState',
    },
    {
      kind: 'attribute',
      name: 'history',
    },
    {
      kind: 'attribute',
      name: 'readyForPayment',
    },
    {
      kind: 'attribute',
      name: 'ignorePolicies',
    },
    {
      kind: 'attribute',
      name: 'amounts',
    },
    {
      kind: 'attribute',
      name: 'lpnDiscountActivated',
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramInstance',
      type: 'tas-program-instance',
      options: {
        async: false,
        inverse: 'tasApplications',
      },
    },
    {
      kind: 'belongsTo',
      name: 'tasProgramLimit',
      type: 'tas-program-limit',
      options: {
        async: false,
        inverse: 'tasApplications',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasAssistances',
      type: 'tas-assistance',
      options: {
        async: false,
        inverse: 'tasApplication',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasCourses',
      type: 'tas-course',
      options: {
        async: false,
        inverse: 'tasApplication',
      },
    },
    {
      kind: 'hasMany',
      name: 'tasAssets',
      type: 'tas-asset',
      options: {
        async: false,
        inverse: 'tasApplications',
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'tags',
      type: 'tag',
      options: {
        async: false,
        inverse: 'taggable',
        as: 'taggable',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsCards',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'tasApplication',
      },
    },
    {
      kind: 'hasMany',
      name: 'aiRecommendations',
      type: 'ai-recommendation',
      options: {
        async: false,
        inverse: 'recommendable',
      },
    },
  ],
});

export default TasApplicationSchema;
